import useAppStore from "@/context/store";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";

import BoardList from "../../../components/BoardList";

import { getSearchMyBoards, getSearchOtherBoards } from "../../../services";

import styles from "./index.module.less";

export default function SearchMyBoardList({ query, empty }) {
  const pageRef = useRef(1);
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);

  const { q, urlname } = query;

  const queryAction = useMemo(() => {
    pageRef.current = 1;
    setDataSource([]);
    setHasMore(true);

    return async () => {
      if (!q) {
        return;
      }

      const per_page = 20;
      const isMe = useAppStore.getState().user?.urlname === urlname;

      let result;
      if (!isMe) {
        result = await getSearchOtherBoards({
          q,
          urlname,
          limit: per_page,
          page: pageRef.current,
        });
      } else {
        result = await getSearchMyBoards({
          q,
          per_page,
          page: pageRef.current,
        });
      }

      const boards = result?.boards || [];

      if (boards.length <= 0) {
        setHasMore(false);
      }
      setDataSource((dataSource) => dataSource.concat(boards));
      setTotal(result?.total || 0);
    };
  }, [q, urlname]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
  }, [queryAction]);

  return (
    <div className={styles.tab}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          {total > 0 && (
            <div className={styles.info}>
              找到 {total} 个与 <span>{q}</span> 相关的画板
            </div>
          )}
          <BoardList
            dataSource={dataSource}
            hideUser={true}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>{empty}</Else>
      </If>
    </div>
  );
}
